import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

import { Section, Title, Text, Span } from "../../components/Core";
import imgPhoto from "../../assets/image/phyppz.jpg";
import funnyCode from "../../assets/image/code.png";
import Emoji from "../../components/Emoji"

const LinkSocial = styled.a`
  color: ${({ theme }) => theme.colors.light} !important;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 1.63px;
  transition: 0.4s;
  &:hover {
    color: ${({ theme }) => theme.colors.light} !important;
    transform: translateY(-5px);
  }
`;

const About = ({ hero = true, bg = "dark", ...rest }) => {
  return (
    <>
      <Section hero={hero} bg={bg} {...rest}>
        <Container>
          <Row className="align-items-center">
            <Col lg="6">
              <div>
                <img src={imgPhoto} alt="folio" className="img-fluid" />
              </div>
            </Col>
            <Col lg="6">
              <div className="pl-lg-4 pt-5 pt-lg-0">
                <Title color="light" variant="secSm">
                  Phyppz Jeudy
                </Title>
                <Text
                  color="light"
                  className="mt-3 mt-lg-5"
                  css={`
                    line-height: 1.5;
                  `}
                >
                  Software developer based in Florida, USA. I'm really passionate about software development.
                  Our modern world is ran by software, so naturally, the ones who write software run the world
                  <Emoji symbol=" 😈. " label="grin"/> 
                  It's my goal to have us run the world together.
                </Text>
                <Text color="light" className="mt-4">
                  I strive for excellence and beautifully functional software.
                </Text>
                <div className="mt-4">
                  <Text color="light">Email me at</Text>

                  <Text variant="p">
                    <a
                      href="mailto:contact@phyppz.anonaddy.me"
                      className="font-weight-bold"
                    >
                      <Span color="light">contact@phyppz.anonaddy.me</Span>
                    </a>
                  </Text>
                </div>
                <div className="mt-5">
                  <img src={funnyCode} alt="sign" className="img-fluid code-snip" />
                </div>
                <Text color="light" className="mt-3 font-weight-bold">
                  Phyppz Jeudy
                </Text>
                <Text color="light" variant="small">
                  Software Engineer
                </Text>
                <div className="mt-5 d-flex">
                  <LinkSocial
                    href="https://www.linkedin.com/in/phyppz-j-3984b7122"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mr-3"
                  >
                    Linkedin
                  </LinkSocial>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Section>
    </>
  );
};

export default About;
